import { markAsCompleted } from './_core'

/**
 * Doc: https://usefulangle.com/post/113/javascript-detecting-element-visible-during-scroll
 * 
 * @param	{Object}	input	
 * @param	{String}	input.cssSelector
 * @param	{Function}	next	
 * @param	{Object}	context	
 * 
 * @return	{Void}
 */
export default function track(input, next, context) {
	try {
		const { debug } = context || {}
		const { id, cssSelector } = input||{}
		if (debug)
			console.log(`INFO - Start tracking 'scroll' event (id: ${id}, cssSelector: ${cssSelector})`)
		
		if (!cssSelector || typeof(cssSelector) != 'string') {
			if (debug)
				console.log(`WARN - CSS selector not defined for 'scroll' event (id: ${id}, cssSelector: ${cssSelector})`)
			markAsCompleted(id, next, context)
			return 
		}

		const result = observe(id, cssSelector, debug, next, context)
		if (!result) {
			// Retry on 3 seconds. Maybe the page is slow and the DOM has not loaded yet.
			if (debug)
				console.error(`ERROR - DOM element for CSS selector ${cssSelector} not found. Trying again in 3 seconds...`)
			
			setTimeout(() => {
				const result = observe(id, cssSelector, debug, next, context)
				if (!result) { // This time we assume the DOM is not on the page. It might be on the next one. We'll set this up via 'pushState' or 'replaceState'. 
					if (debug)
						console.error(`ERROR - No luck. The DOM element for CSS selector ${cssSelector} is still not found. Programming another check when the page reloads or changes.`)
					const apply = (target, thisArg, args) => {
						setTimeout(() => {
							observe(id, cssSelector, debug, next, context)
						}, 2000)

						return target.apply(thisArg, args)
					}
					window.history.pushState = new Proxy(window.history.pushState, { apply })
					window.history.replaceState = new Proxy(window.history.replaceState, { apply })
				}
			}, 3000)
		}
	} catch(err) {
		console.error(`ERROR - Failed to track 'scroll' instruction. Details: ${err.stack||err.message}`)
	}
}


const observe = (id, cssSelector, debug, next, context) => {
	try {
		const els = document.querySelectorAll(cssSelector)
		const el = els[0]
		if (els.length > 1 && debug)
			console.log(`WARN - Found more than one DOM element matching CSS selector ${cssSelector}. Using the first one and ignoring the others for 'scroll' event id: ${id}.`)
		if (el) {
			if (debug)
				console.log(`INFO - Start observing 'scroll' event for element <${el.tagName}> (CSS selector ${cssSelector})`)

			const observer = new IntersectionObserver(entries => {
				if(entries[0].isIntersecting === true)
					markAsCompleted(id, next, context)
			}, { threshold: [0] })
			observer.observe(el)
			
			if (debug)
				console.log(`INFO - Successfully observing 'scroll' event for element <${el.tagName}> (CSS selector ${cssSelector})`)
			return true
		} else 
			return false
	} catch(err) {
		console.error(`ERROR - Failed to observe 'scroll' on CSS selector ${cssSelector}. Details: ${err.stack||err.message}`)
		throw err
	}
}



